const domain: string = 'https://ogma.osi.office.net';
const translateEndpoint: string = '/TradukoApi/api/v1.0/translateContent';
const supportedLanguagesEndpoint: string = '/TradukoApi/api/v1.0/supportedLanguages';

export function getOgmaTranslateUri(targetLang: string): string {
    return `${domain}${translateEndpoint}?fromLang=&toLang=${targetLang}`;
}

export function getOgmaSupportedLanguagesUri(clientLocale: string): string {
    return `${domain}${supportedLanguagesEndpoint}?clientLocale=${clientLocale}`;
}
